import React from "react";

const NoImages = () => (
  <div>
    <h2>image non trouvée</h2>
    <p>Essayer avec un autre terme</p>
  </div>
);

export default NoImages;